// Sonar: a question put to the panel, its study, its steps and its study note.
export default {
  sousTitre: {
    format: 'A question about a format, put to the panel: what it chooses, what it prefers, what it says',
    explorer: 'An open question, put to the audiences you choose: what they choose, what they prefer, what they say',
  },
  // Explore's examples; a project's Sonar has none.
  exemples: {
    e1: 'Should public transport be free?',
    e2: 'Who should host the next Star Academy?',
    e3: 'What should a new organic yoghurt brand be called?',
    e4: 'Would people pay for news without advertising?',
  },
  erreur: {
    etudes: 'Studies could not be read',
    question: 'Question refused',
    etude: 'Study could not be read',
    modification: 'Change not saved',
    lancement: 'Launch refused',
  },
  mots: {
    choix: {
      pastille: 'Multiple choice',
      liste: 'Answers offered to the panel',
      ajout: 'Add an answer',
      compte: '{n} answers | {n} answer | {n} answers',
      garder: 'Keep at least {nb} answers.',
    },
    notation: {
      pastille: 'List to rate',
      liste: 'What the panel will rate, from 0 to 10',
      ajout: 'Add an item',
      compte: '{n} items | {n} item | {n} items',
      garder: 'Keep at least {nb} items.',
    },
    combinaison: {
      pastille: 'Combinations',
      liste: 'Proposed candidates',
      ajout: 'Add a name',
      compte: '{n} candidates | {n} candidate | {n} candidates',
      garder: 'Keep at least {nb} candidates.',
    },
  },
  statut: {
    candidats_en_cours: 'Being designed',
    elicitation_a_creer: 'Open question being prepared',
    elicitation_protocole: 'Open question being prepared',
    elicitation_en_cours: 'The panel is suggesting',
    candidats: 'To review',
    notation_a_creer: 'Rating being prepared',
    notation_protocole: 'Rating being prepared',
    notation_en_cours: 'The panel is rating',
    choix_a_creer: 'Run being prepared',
    choix_protocole: 'Run being prepared',
    choix_en_cours: 'The panel is answering',
    rendu: 'Delivered',
    echec: 'Stopped',
  },
  signal: {
    en_ligne: 'Rising online',
    terrain: 'Your audiences talk about them',
    notoriete: 'Safe bet',
    panel: 'Suggested by the panel',
  },
  avancement: {
    nomsSansListe: 'The panel suggests its own names, without a list.',
    ideesSansListe: 'The panel suggests its own ideas, without a list.',
    panelARepondu: '{pct} of the panel has answered.',
    voteSuivra: 'The voting list will follow.',
    panelNote: 'The panel rates each item from 0 to 10.',
    departageSuivra: 'The head-to-head will follow automatically.',
    tirEnFile: 'The run is queued behind today’s runs: it will start as soon as a slot frees up.',
    panelRepond: 'The panel is answering the question.',
    departageEnFile: 'Rating is done. The head-to-head between combinations is queued behind today’s runs: it will start as soon as a slot frees up.',
    panelDepartage: 'The panel is choosing between the combinations, against last season.',
    reponsesRecues: '{pct} of answers received.',
  },
  deja: {
    role: 'Returning {role}',
    jamaisRole: 'New {role}',
    vu: 'Seen before',
    nouveau: 'New',
  },
  panneau: {
    ouverte: 'What the panel is looking for',
    vote: 'What the panel says about the vote',
    combinaison: 'What the panel says about the combination',
  },
  liste: {
    poser: 'Put your question to the panel',
    publics: 'Audiences surveyed',
    concevoir: 'Design the study',
    jeRelis: 'I review before the vote',
    vosQuestions: 'Your questions',
    aucune: 'No questions asked yet.',
  },
  autonome: 'Autonomous',
  chargement: 'Loading…',
  combinaisonDe: 'of {nb} {roles}',
  poseePar: 'Asked by {nom}',
  archiver: 'Archive',
  archiverConfirmer: 'Confirm archiving',
  noteDEtude: 'Study note',
  toutesLesQuestions: 'All questions',
  conception: {
    sujet: 'Orion is researching the topic and choosing whom to ask.',
    sujetPublicsChoisis: 'Orion is researching the topic.',
    etude: 'Orion is designing the study.',
  },
  lecture: {
    territoire: 'Territory',
    tranche: 'Segment',
  },
  ensemble: 'Overall',
  titre: {
    explorer: 'Explore',
    nomsSansListe: 'Names the panel suggests, without a list',
    ideesSansListe: 'What the panel suggests, without a list',
    recherche: 'What the panel is looking for',
    reponseDuPanel: 'What the panel answers',
    voteCandidats: 'The vote, candidate by candidate',
    voteElements: 'The vote, item by item',
    enDit: 'What the panel says',
    combinaisonGagnante: 'The winning combination',
    candidatGagnant: 'The winning candidate',
  },
  nouveaux: {
    ecran: '{pct} {phrase}, {distincts} {differents}.',
    livrable: '{pct} {phrase}; {distincts} {differents}.',
    personnes: 'of the panel suggest someone who has never been in the {role} role',
    personnesSansRole: 'of the panel suggest someone who has never been in this role',
    idees: 'of the panel suggest something the programme has never done',
  },
  distincts: {
    personnes: 'different names',
    idees: 'different answers',
  },
  dansLeVoteAria: 'In the vote',
  voirTous: {
    personnes: 'See all {nb} names',
    idees: 'See all {nb} answers',
  },
  legende: {
    ensemble: 'Overall',
    dansLeVote: 'in the vote',
  },
  interroger: {
    panel: 'Ask the panel',
    reponse: 'Ask those who answered “{option}”',
    ceuxQuiLaVeulent: 'Ask those who want it',
    jury: 'Ask those who would want to watch with {noms}',
  },
  relecture: {
    question: 'The question put to the panel',
    proposeParLePanel: 'The vote: what the panel suggested',
    repere: 'The reference:',
    ajouteeParVous: 'Added by you',
    ajouteParVous: 'Added by you',
    presentation: 'Their introduction is being written.',
    ceQuiSeDit: 'What people are saying:',
    enCeMoment: 'Right now:',
    ajouter: 'Add',
    lancerVote: 'Launch the vote',
    lancerEtude: 'Launch the study',
  },
  cibleParCible: 'Target by target',
  duo: {
    titre: 'Ages 3-7: the child asks, the parent decides',
    suit: 'Parents go along with their child {pct} of the time',
    reclame: 'What the child asks for',
    retient: 'What the parent settles on',
  },
  envie: '{pct} would want to watch',
  faceDerniereSaison: ', {pts} against last season',
  partProjetee: 'Projected audience share (individuals 4+)',
  scenarios: '{bas} ~ {haut}',
  repereLegende: '{libelle}: {pct}',
  etape: {
    attente: 'Upcoming',
    cours: 'In progress',
    relire: 'To review',
    faite: 'Done',
    replier: 'Collapse step',
    deplier: 'Expand step',
  },
  idees: {
    temoignages: 'Quotes: {titre}',
  },
  notation: {
    interroger: 'Ask those who like {nom}',
    echelle: 'from 0 to 10',
  },
  citation: '“{texte}”',
  livrable: {
    laQuestion: 'The question',
    seulTerritoire: 'Results for the {territoire} territory only, out of those surveyed: {liste}.',
    territoiresInterroges: 'Territories surveyed: {liste}. | Territory surveyed: {liste}. | Territories surveyed: {liste}.',
    questionOuverte: 'The open question: “{question}”',
    auVote: 'In the vote',
    ceQuiRevient: 'What comes up',
    reponse: 'Answer',
    territoireParTerritoire: 'Territory by territory',
    noteSur10: 'Score out of 10',
    enTete: 'leading',
    partProjetee: '; projected audience share (individuals 4+): {pct}{bornes}',
    faceDerniereSaison: 'Against last season',
    repere: 'reference',
  },
}
